import { OneWaySlabInput } from '@core/const'
import { Dispatch, PropsWithChildren, SetStateAction, createContext, useContext, useMemo, useState } from 'react'
import { UseFormReturn, useForm } from 'react-hook-form'

const defaultFormValues: OneWaySlabInput = {
  slabType: 'CANTILEVER',
  beamSpan: 0,
}

interface OneWaySlabContext {
  form: UseFormReturn<OneWaySlabInput>
  result: number | null
  setResult: Dispatch<SetStateAction<number | null>>
}

const context = createContext<OneWaySlabContext | undefined>(undefined)

const useDefaultContextValues = () => {
  const form = useForm<OneWaySlabInput>({
    defaultValues: defaultFormValues,
  })

  const [result, setResult] = useState<number | null>(null)

  return useMemo(() => ({
    form,
    result,
    setResult,
  }), [form, result])
}

export function OneWaySlabProvider ({ children }: PropsWithChildren) {
  const { Provider } = context
  const defaultContextValues = useDefaultContextValues()

  return (
    <Provider value={defaultContextValues}>
      {children}
    </Provider>
  )
}

export const useOneWaySlab = () => {
  const contextValues = useContext(context)
  const defaultContextValues = useDefaultContextValues()

  return contextValues ?? defaultContextValues
}
